import { useCallback } from 'react'

import { useLatestRef } from './useLatestRef'

type AnyFunction = (...args: any[]) => any

export function useStableCallback<T extends AnyFunction>(callback: T): T {
  const callbackRef = useLatestRef(callback)

  const stableCallback = useCallback(
    (...args: Parameters<T>) => callbackRef.current(...args),
    [callbackRef],
  )

  return stableCallback as T
}
